import { RealtimeAssistantActions } from 'actions/actionTypes';

const initialState = {
  methodology: []
};

const realtimeAssistant = (state = initialState, action) => {
  switch (action.type) {
    case RealtimeAssistantActions.FETCH_REALTIME_ASSISTANT_SUCCESS:
      return {
        ...state,
        methodology: [...action.methodology]
      };
    case RealtimeAssistantActions.RESET_REALTIME_ASSISTANT:
      return initialState;
    default:
      return state;
  }
};

export default realtimeAssistant;
